module.exports = __webpack_public_path__ + "static/media/user.62557457.svg";